export const COMMUNITY = "communityIds";
export const ZONE = "zoneIds";
export const BLOCK = "blockIds";
export const OCCUPANCY = "occupancy";
export const SEARCH = "search";
export const OUTSTANDING_DUES = "outstandingDuesOnly";

export const OWNER = "OWNER";
export const TENANT = "TENANT";
export const LANDLORD = "LANDLORD";
export const PROPERTY_MANAGER = "PROPERTY_MANAGER";

export const occupancyOptions = [
  { label: "Owner", value: OWNER },
  { label: "Tenant", value: TENANT },
  { label: "Landlord", value: LANDLORD },
  { label: "Property Manager", value: PROPERTY_MANAGER },
];

export const CURRENT = "current";
export const HISTORY = "history";

export const occupantsTabs = [
  {label: 'Current', value: CURRENT},
  {label: 'History', value: HISTORY},
];

export const ALL = "all";
export const OPEN = "open";
export const CLOSE = "close";

export const incidentTabs = [
  {label: 'All', value: ALL},
  {label: 'Open', value: OPEN},
  {label: 'Close', value: CLOSE},
]